import { render, staticRenderFns } from "./RadarBasic.vue?vue&type=template&id=52698ef8&scoped=true&"
import script from "./RadarBasic.vue?vue&type=script&lang=js&"
export * from "./RadarBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52698ef8",
  null
  
)

export default component.exports